import React,  { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { listTower, unloadTowerList } from '../../modules/tower/towersSlice';

import TowerList from './TowerList';

const TowerListContainer = () => {
    const dispatch = useDispatch();
    // const { projectId } = useParams;
    const [searchParams] = useSearchParams();

    const towers = useSelector(state => state.towers.towers);
    const error = useSelector(state => state.towers.error);
    const loading = useSelector(state => state.loading);
    const user = useSelector(state => state.user.user);
    const project = useSelector(state => state.project.project);
    const projectId = project?._id;

    useEffect(() => {
        const tag = searchParams.get('tag');
        const page = parseInt(searchParams.get('page'), 10) || 1;
        const username = user?.username;
        dispatch(
            listTower({
                projectId,
                page,
                username,
                tag,
            }),
        );
        
        // 언마운트될 때 리덕스에서 타워 리스트 지우기
        return () => {
            dispatch(unloadTowerList());
        };
    }, [dispatch, projectId, searchParams, user?.username]);



    return (
        <TowerList
            loading={!loading}
            error={error}
            towers={towers}
            project={project}
            user={user}
        />
    );
};

export default React.memo(TowerListContainer);
